import * as React from 'react'

function SvgFunArrowDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 17a.997.997 0 01-.707-.293l-7-7a.999.999 0 111.414-1.414L12 14.586l6.293-6.293a.999.999 0 111.414 1.414l-7 7A.997.997 0 0112 17" />
    </svg>
  )
}

export default SvgFunArrowDown
